import noop from 'lodash/noop';
import { createContext } from 'react';

const RecentSearchesContext = createContext(noop);

export default RecentSearchesContext;
